import { Link, Paper, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Info } from "@/components/VulnerabilityWatch/Info.tsx";
import type { KnownPortalOverview } from "@/types";
import { sourcesHref } from "@/utils/sourcesFilters.ts";
import * as copy from "@/utils/vulnerabilityCopy.ts";

export default function NamedLaterSection({ overview }: { readonly overview: KnownPortalOverview | null }) {
  const namedLater = overview?.named_later ?? null;
  return (
    <Paper variant="outlined" component="section" aria-label={copy.NAMED_LATER} sx={{ p: 3 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{copy.NAMED_LATER}<Info text={copy.TIP_NAMED_LATER} /></Typography>
      {namedLater === null ? (
        <Typography color="text.secondary">{copy.NOT_KNOWN}</Typography>
      ) : (
        <Link component={RouterLink} to={sourcesHref({ namedLater: true })}>
          {copy.namedLaterLabel(namedLater.requests, namedLater.addresses)}
        </Link>
      )}
    </Paper>
  );
}
